import { render, staticRenderFns } from "./TickerSettings.vue?vue&type=template&id=680fb40a&scoped=true"
import script from "./TickerSettings.vue?vue&type=script&lang=js"
export * from "./TickerSettings.vue?vue&type=script&lang=js"
import style0 from "./TickerSettings.vue?vue&type=style&index=0&id=680fb40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680fb40a",
  null
  
)

export default component.exports